import styled from "styled-components";
import {
  DataHeading,
  UnderlineLink,
  DisplayFlex,
  SecondaryButtonComponent,
  GhostButtonComponent,
  CommonTable
} from "../../../../CommonComponents/commonStyles";

import { Modal, Divider, Select, DatePicker, Dropdown, Icon } from "antd";

import { styleConfig } from './styleConfig';

const { RangePicker } = DatePicker;

export const PageAccountSummary = styled.div`
font-size:${props => props.theme.fontSize.primary};
color:  ${props => props.theme.fontColors.textColor};
font-family: ${props => props.theme.fontFamily.helveticaNeue};
  display: flex;
  flex-direction:column !important;

  .ant-divider:last-child {
    display: none;
  }
  @media only screen and (max-width: 560px) {
    flex-direction: column;
  }
`;

export const Label = styled.div`
font-size:${props => props.theme.fontSize.primary};
color:  ${props => props.theme.fontColors.textColor};
`;

export const Number = styled.div`
  font-size: ${props => props.theme.fontSize.h4};
  font-family: ${props =>
  props.theme.fontFamily.helveticaNeueBold} ;
  max-width:280px;
  overflow:hidden;
  color: #505050;
`;

export const FundSummaryContainer = styled.div`
  display: flex;
  margin: ${props => props.theme.spacing.margins.webBase} 0 ${props => props.theme.spacing.margins.webTwiceBase} 0;
  .ant-divider:last-child {
    display: none;
  }
  @media only screen and (max-width: 560px) {
    flex-direction: column;
  }
`;

export const FundSummaryContent = styled.div`
  margin-right: ${props => props.isNoMargin ? '0' : '101px'};
  position: relative;
  &::after {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    right: -50px;
    background-color: #505050;
    top: 0;
  }
  &:last-child:after {
    display: none;
    margin-bottom: 0;
  }
  @media only screen and (max-width: 560px) {
    display: flex;
    justify-content: space-between;
    margin-right: 0;
    margin-bottom: 2.5rem;
    &:last-child {
      margin-bottom: 0;
    }
    &::after {
      content: '';
      height: 1px;
      width: 100%;
      position: absolute;
      right: 0;
      margin-right: 0;
      background-color: ${props => props.theme.backgroundColor.summaryDivider};
      top: 2.5rem;
  }
  }
`;


export const CharityHeading = styled.div`
  color: #505050;
  font-size:20px;
  margin-top:10px;
  padding-bottom:20px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;
export const NoteBox = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  padding: 50px 0px 0px 0px;
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;


export const DropdownList = styled(Dropdown)`
  z-index: 1 !important;
  width:80px;
  border:1px solid #eee;
  & > .ant-dropdown {
    z-index: 1 !important;
    left: 15.5px;
    top: 520px;
    width: 85%;
  }
`;

export const InfoContentWrapper = styled.div`
  padding: 0 6% 0 6%;
  position: fixed;
  background: #ffffff;
  width: 55%;
  height: 450px;
  // height: 69%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;

  @media only screen and (min-width: 426px) and (max-width: 768px) {
    width: 76%;
  }

  @media only screen and (min-width: 769px) and (max-width: 1024px) {
    width: 60%;
  }

  .ant-calendar-picker {
    display: none !important;
  }
  .ant-calendar-picker-container{
    position: absolute !important;
    left: 50% !important;
    top: 46% !important;
    transform: translate(-50%, -50%) !important;
    @media only screen and (min-width: 427px) and (max-width: 768px) {
      left: 65%;
    }
  }

  .ant-calendar-input-wrap{
    border-bottom: 0;
  }

  .ant-calendar-range .ant-calendar-body, .ant-calendar-range .ant-calendar-month-panel-body, .ant-calendar-range .ant-calendar-year-panel-body{
    border-top: 0;
  }

  .ant-calendar{
    box-shadow: 0 0 0 rgba(0,0,0,0) !important;
  }
  .ant-calendar-range-left .ant-calendar-input, .ant-calendar-range-left .ant-calendar-time-picker-input{
    padding-left: 97px;
  }

  .ant-calendar-range-right .ant-calendar-input, .ant-calendar-range-right .ant-calendar-time-picker-input{
    padding-left: 185px;
  }
  
  .ant-calendar-range-middle {
    padding-left:201px;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 510px;
    width: 87.5%;
  }
`;


export const CustomDatePicker = styled(RangePicker)`
 width: 100%;
.ant-calendar-picker-container{
  left: 453px;
  top: 440px;
}
`;

export const DateWrapper = styled.div`
display: flex;
justify-content: center;
position: relative;
background: ${props => props.theme.backgroundColor.layoutLight};
height: 306px;
.ant-row{
  width: 100%;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  height: 326px;
}
`;

export const ExchangeContainer = styled.div`
  margin-top: 170px;
`;

export const LabelDataHeading = styled(DataHeading)`
  color:${props => props.theme.fontColors.textColor};
`;

export const ValueDataHeading = styled(DataHeading)`
  color: ${props => props.theme.fontColors.textColor};
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  text-transform: capitalize;
`;


export const StyledLoader = styled(Icon)`
font-size: ${props => props.theme.fontSize.h5};
`

export const MobileIconStyle = styled.div`
  color: ${props => props.theme.fontColors.textColor};
  margin-top:5px;
`;

const grantsActivityMixin = (selector='', styles) => {

  if(styles && selector) {
    return `
      &.${selector} .ant-table-thead .ant-table-header-column {
        width: ${styles.defaultWidth}px;
      }
      
      &.${selector} .ant-table-tbody .ant-table-row td div{
        width: ${styles.defaultWidth}px;
      }

      ${
        styles.customStyles.map(style => {
          return `
            ${ style.sorterPos ? 
                `&.${selector} .ant-table-thead th:nth-child(${style.column}) .ant-table-header-column .ant-table-column-sorter {
                  left: ${style.sorterPos}px !important;
                }`: '' }        

            &.${selector} .ant-table-thead th:nth-child(${style.column}) .ant-table-header-column {
              width: ${style.width}px;     
            }
      
            &.${selector} .ant-table-thead th:nth-child(${style.column}) .ant-table-header-column .ant-table-column-title {
              width: ${style.width}px;
              text-align: ${style.textAlign};
            }

            &.${selector} .ant-table-row td:nth-child(${style.column}) div{
              width: ${style.width}px;
              text-align: ${style.textAlign};
            }
          `
        }).join('')
      } 
    `    
  }

  return;
}

export const GrantTable = styled(CommonTable)`

  .ant-table-scroll table {
    table-layout: fixed;
  }

  .ant-table-header {
    overflow: hidden !important;  
  }

  .infotooltip {
    padding: 0px 3px;
  }

  &.grantActivitySortIcon .ant-table-fixed-header .ant-table-scroll, 
  &.grantActivitySortIcon .ant-table-body,
  &.investmentExchangeSortIcon .ant-table-fixed-header .ant-table-scroll, 
  &.investmentExchangeSortIcon .ant-table-body {
    border-top: 1px solid #eaeaea !important;
  }

  &.grantActivitySortIcon .ant-table-body::-webkit-scrollbar {
    width: 10px;
  }

  &.grantActivitySortIcon .ant-table-body::-webkit-scrollbar-thumb {
    background: rgba(0, 103, 120, 0.6);
    border-radius: 5px;
  }

  &.grantActivitySortIcon .ant-table-header table {
    padding-right: ${props => props.ie ? '17px': '6px'}
  }

  &.grantActivitySortIcon .ant-table-thead tr th .ant-table-column-sorter {
    left: -13px !important;
  }

  .ant-table-body {
    overflow-x: hidden !important;
  }

  &.grantsTab .ant-table-thead th {
    padding: 12px;
  }

  &.grantsTab .ant-table-row td {
    padding: 12px;
  }  

  @media only screen and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    &.grantActivitySortIcon .ant-table-thead th .ant-table-header-column .ant-table-column-sorter {
      padding-top: 3px;
    }
  }

  ${ props =>  {

      const tableClassName = props.className ? props.className.split(" ")[2]: '';    

      return `@media screen and (min-width: 1174px) {
        ${grantsActivityMixin(tableClassName, styleConfig.desktop[tableClassName])};
      }

      @media screen and (max-width: 1173px) {
        ${grantsActivityMixin(tableClassName, styleConfig.ipadPro[tableClassName])};
      }`

    }

  }
`;


export const UnderlyingContent = styled(UnderlineLink)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  line-height: 1.38;
`;

export const CustomModal = styled(Modal)`
  .ant-modal-header {
    padding: 0px 0px 30px 0px;
    border-bottom: 2px solid #b6bdbd;
    @media only screen and (max-width: 576px) {
      padding: 0px 0px 15px 0px;
    }
  }
  .ant-modal-footer {
   display:none;
  }
  .ant-modal-body {
    padding: 12px 0px 10px 0px;
    @media only screen and (max-width: 576px) {
      height:160px;
    }
    .ant-table-wrapper {
      border-top: 1px solid #b6bdbd;
    }
  }
  .ant-modal-content {
    border-radius: 0px;
    padding: 32px 
    height:10px !important;
    width:10px;
    left:50%!important;
    top:60% !important;
    @media only screen and (max-width: 576px) {
      padding: 30px 20px;
      top:50% !important;
      height:125px;
    }

    @media only screen (min-width: 600px) and (max-width: 991px) {
      height: 80vh;
      display: flex;
      flex-direction: column;
      margin-top:10%;
    }
  }
  @media only screen and (max-width: 991px) {
    width: 98% !important;
    height: 97vh;
    top: 10px;
    padding: 0;
  }
  @media only screen and (max-width: 576px) {
    top: 0px !important;
  }
`;

export const CustomModalMob = styled(Modal)`
  .ant-modal-header {
    padding: 0px 0px 30px 0px;
    border-bottom: 2px solid ${props => props.theme.border.unchecked};
    @media only screen and (max-width: 576px) {
      padding: 0px 0px 15px 0px;
    }
  }
  .ant-modal-footer {
    padding: 0px 0px 0px 0px;
    display: flex;
    justify-content: center;
    text-align: center;
    div {
      margin-top: 20px;
    }
    @media only screen and (max-width: 991px) {
      padding-top: 0;
      margin-top: auto;
    }
    @media only screen and (max-width: 576px) {
     .ant-btn-primary{
      background-color: #006778;
      border-color: #006778;
     }
    }
  }
  .ant-modal-body {
    padding: 12px 0px 10px 0px;
    @media only screen and (max-width: 576px) {
      height:150px;
    }
   
     .ant-table-wrapper {
      border-top: 1px solid #b6bdbd;
      
    }
  }
  .ant-modal-content {
    border-radius: 0px;
    padding: 30px 
    @media only screen and (max-width: 576px) {
      padding: 30px 20px;
      top:50% !important;
      height:125px;

    }

    @media only screen and (max-width: 768px) {
      height: 50vh;
      display: flex;
      flex-direction: column;
    }

    @media only screen (min-width: 768px)  and (max-width: 991px) {
      height: 80vh;
      display: flex;
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 991px) {
    width: 98% !important;
    height: 97vh;
    top: 10px;
    padding: 0;
  }
  @media only screen and (max-width: 576px) {
    top: 0px !important;
  }
`;

export const ContentDivider = styled(Divider)`
  border: solid 0.5px rgba(255, 255, 255, -10.7);
  margin-top: 20px;
  margin-bottom: 15px;
`;

export const Para = styled.div`
  span {
    display: block;
  }
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: #505050;
  margin: 20px 0px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const CommentsMargin = styled.div`
  .ant-form-item {
    margin-bottom: 15px;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 15px;
    margin-left: 20px;
  }
`;



export const MobDatePicker = styled(DatePicker)`
  width:100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .ant-calendar-picker-container{
    top: ${props => `${props.top}px !important`}
  }
 
`;

export const GrantDisplayFlex = styled(DisplayFlex)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const GrantGhostButton = styled(GhostButtonComponent)`
  width: 177px;
  margin-right: 15px;
  font-size: ${props => props.theme.fontSize.heading};
  font-weight: 900;
  line-height: 1.67;
  letter-spacing: 1.1px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    margin-bottom: 15px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
export const GrantPrimaryButtonWrapper = styled.div`
  width: 177px;
  font-size: ${props => props.theme.fontSize.heading};
  font-weight: 900;
  letter-spacing: 1.1px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    margin-bottom: 70px;
  }
`;

export const DeleteModal = styled(Modal)`
  &&& {
    .ant-modal-content {
      border-radius: 0px;
    }
    .ant-modal-header {
      padding: 15px 30px 15px 30px;
      background: #fff;
      border-radius: unset;
      @media (max-width: 576px) {
        padding: 10px 15px;
      }
    }
    .ant-modal-title {
      text-align: center;
      font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
      font-size: ${props => props.theme.fontSize.h4};
      font-weight: ${props => props.theme.fontWeight.normal};
      line-height: ${props => props.theme.lineHeight.h4};
      color: ${props => props.theme.fontColors.headingColor};
    }
    .ant-modal-footer {
      padding: 16px 20px;
      display: flex;
      justify-content: flex-end;
      border-top: 1px solid #dddddd;
      border-radius: 0 0 4px 4px;
    }
  }
`;

export const GrantInputRadio = styled.div`
  margin-bottom: 30px;
`;

export const SelectTab = styled(Select)`
width: 200px;
max-width: 200px;
height:40px;

.ant-select-selection{
  border-radius : 0px;
}

& .ant-select-selection--multiple .ant-select-selection__placeholder{
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color:   color: ${props => props.theme.fontColors.tbody}!important;;
}

.ant-select-selection__rendered > ul > li{
  // margin-top:7px;
}

.ant-select-arrow{
  top: 0;
    padding: 13px 13px;
    background-color: ${props => props.theme.colors.grayColor};
    margin: 1px 1px;
    right: 0;
    bottom: 0;
}
`;

export const ViewMoreButton = styled(SecondaryButtonComponent)`
  min-width: 90%;
  width: 99px;
  font-size: 14px;
  font-weight: 700;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  // width:auto !important;
  text-decoration: none;
  padding: 0px 8px;
  margin: 20px 13px;

  @media only screen and (max-width: 991.92px) {
    margin:0px;
    // height:30px;
    // line-height:
  }
`;

export const Content = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
color: ${props => props.theme.fontColors.textColor};
`;

export const Underlined = styled.a`
  font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-weight: 700;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.heading};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.primaryColor};
  text-decoration: underline;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  line-height: 1.38;
  letter-spacing: 0.6px;
  &:hover {
    color: ${props => props.theme.colors.primaryColor};
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  @media only screen and (max-width: 576px) {
    line-height: ${props => props.theme.lineHeight.primary};
  }
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
`;
